import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { getHotVideos } from "@/lib/videos";
import { newsList } from "@/mocks/news";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import SectionHeader from "@/components/feature/SectionHeader";
import VideoCard from "@/components/feature/VideoCard";
import NewsCard from "@/components/feature/NewsCard";

const HOME_META = {
  title: "CC视频 - 精选影视视频内容平台",
  description:
    "CC视频提供丰富的影视视频资源和最新影视资讯，涵盖电影、电视剧、综艺等多种类型，满足用户在线观看和内容浏览需求。",
  keywords:
    "CC视频,影视视频,电影资源,电视剧,视频资讯,影视平台,在线视频,影视内容",
};

const stats = [
  { value: "12000+", label: "收录影视作品" },
  { value: "32", label: "细分内容类型" },
  { value: "每日", label: "更新影视资讯" },
  { value: "全端", label: "多设备浏览体验" },
];

export default function Home() {
  usePageMeta(HOME_META);

  const hotVideos = getHotVideos(8);
  const featureNews = newsList[0];
  const sideNews = newsList.slice(1, 5);

  return (
    <div className="pb-16 md:pb-20">
      <HeroCarousel />

      <section className="max-w-content mx-auto px-4 md:px-6 mt-10 md:mt-14">
        <SectionHeader
          title="内容分类"
          subtitle="三大频道，快速进入你感兴趣的内容"
        />
        <CategoryEntry />
      </section>

      <section className="max-w-content mx-auto px-4 md:px-6 mt-12 md:mt-16">
        <SectionHeader
          title="热门影视资源精选"
          subtitle="根据近期热度与口碑为你挑选"
          moreTo="/category/movie"
          moreLabel="进入电影频道"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </section>

      <section className="max-w-content mx-auto px-4 md:px-6 mt-12 md:mt-16">
        <SectionHeader
          title="最新影视资讯"
          subtitle="新片速递、行业动态与幕后揭秘"
          moreTo="/news"
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <NewsCard news={featureNews} variant="block" />
          <div className="flex flex-col gap-3">
            {sideNews.map((news) => (
              <NewsCard key={news.id} news={news} />
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-content mx-auto px-4 md:px-6 mt-12 md:mt-16">
        <div className="rounded-lg bg-primary-900 px-6 py-10 md:px-12 md:py-12">
          <div className="flex flex-col lg:flex-row lg:items-center gap-8">
            <div className="lg:max-w-md">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                关于 CC视频
              </h2>
              <p className="mt-3 text-background-300 leading-relaxed text-sm md:text-base">
                我们致力于打造清晰、友好、值得信赖的影视内容导览平台。不提供播放与下载，专注做好内容聚合、分类与发现，让你更快找到想看的作品。
              </p>
              <Link
                to="/about"
                className="mt-6 inline-flex items-center gap-1.5 h-11 px-6 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 flex-1">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg bg-primary-800 p-4 text-center"
                >
                  <p className="text-xl md:text-2xl font-heading font-bold text-accent-300">
                    {s.value}
                  </p>
                  <p className="mt-1 text-xs text-background-300">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}